module.exports = new __parcel__URL__("somashekar.51c471a2.png").toString();